export default __webpack_public_path__ + "static/media/ssapMarketV2.812628cf.svg";